module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-page"
    }
  }, [_c('task-text', {
    ref: "container",
    attrs: {
      "fontname": _vm.task.fontname
    }
  }), _c('task-images', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images),
      expression: "images"
    }],
    attrs: {
      "images": _vm.images,
      "fixation": _vm.fixation
    },
    on: {
      "show": _vm.onImageShow,
      "hide": _vm.onImageHide
    }
  }), _c('div', {
    staticClass: "is-bottom-right"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasNextPage),
      expression: "hasNextPage"
    }],
    staticClass: "button is-primary is-large",
    attrs: {
      "disabled": _vm.isWaitingToFinilizePage
    },
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tokens['btn_next']))])]), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLastPage),
      expression: "isLastPage"
    }],
    staticClass: "button is-primary is-large",
    attrs: {
      "disabled": _vm.isWaitingToFinilizePage
    },
    on: {
      "click": _vm.finish
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tokens['btn_finish']))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30436e93"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/task/TaskPage.vue
// module id = 411
// module chunks = 0